import { render, staticRenderFns } from "./ImageView.vue?vue&type=template&id=982cc4f8&scoped=true"
import script from "./ImageView.vue?vue&type=script&lang=js"
export * from "./ImageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.28_css-loader@6.11.0_webpack@5.105.0__lodash@4.17.23_igavytiafgosz6q2bphdaa3wbq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "982cc4f8",
  null
  
)

export default component.exports